import Icon from '../components/Icon.vue'

Icon.register({"compress":{"width":448,"height":512,"paths":[{"d":"M436 192H312C298.7 192 288 181.3 288 168V44C288 37.4 293.4 32 300 32H340C346.6 32 352 37.4 352 44V128H436C442.6 128 448 133.4 448 140V180C448 186.6 442.6 192 436 192zM160 168V44C160 37.4 154.6 32 148 32H108C101.4 32 96 37.4 96 44V128H12C5.4 128 0 133.4 0 140V180C0 186.6 5.4 192 12 192H136C149.3 192 160 181.3 160 168zM160 468V344C160 330.7 149.3 320 136 320H12C5.4 320 0 325.4 0 332V372C0 378.6 5.4 384 12 384H96V468C96 474.6 101.4 480 108 480H148C154.6 480 160 474.6 160 468zM352 468V384H436C442.6 384 448 378.6 448 372V332C448 325.4 442.6 320 436 320H312C298.7 320 288 330.7 288 344V468C288 474.6 293.4 480 300 480H340C346.6 480 352 474.6 352 468z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/compress.js
// module id = null
// module chunks = 